"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addIndexToPaths = addIndexToPaths;
exports.assignObj = assignObj;
exports.getAllDataFromNameMap = getAllDataFromNameMap;
exports.getComponent = void 0;
exports.getDataCloneFromNameMap = getDataCloneFromNameMap;
exports.getDataFromNameMap = getDataFromNameMap;
exports.getDataProxyFromNameMap = getDataProxyFromNameMap;
exports.getFormId = getFormId;
exports.getPath = getPath;
exports.getValue = getValue;
exports.pathsToString = pathsToString;
exports.recursionData = recursionData;
exports.validateRule = exports.resolvePathForm = exports.resolvePath = void 0;

var _lodash = require("lodash");

var _tools = require("./tools");

var _validates = _interopRequireDefault(require("./validates"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * form rules 全局规则
 * https://github.com/nevergiveup-j/react-form-validates
 */
var validateRule = _validates.default;
/**
 * 解析path转成数组
 * @param {string} path
 * return {array}
 */

exports.validateRule = validateRule;

var resolvePath = function resolvePath(path) {
  if (Array.isArray(path)) {
    return path;
  }

  if (typeof path === 'number') {
    return [path];
  }

  var paths = [];

  if (typeof path === 'string') {
    path.replace(/([a-zA-Z0-9_]+)/g, function (text) {
      return paths.push(text);
    });
  }

  return paths;
};

exports.resolvePath = resolvePath;

function recursionData(datas) {
  var nameMap = datas.nameMap,
      data = datas.data,
      dataClone = datas.dataClone,
      dataProxy = datas.dataProxy,
      paths = datas.paths;
  var thisPath = resolvePath(paths);
  var target = (0, _lodash.get)(nameMap, thisPath);

  if (!target) {
    (0, _lodash.set)(nameMap, thisPath, {
      _data: data,
      _dataClone: dataClone,
      _dataProxy: dataProxy
    });
  } else {
    target._data = data;
    target._dataClone = dataClone;
    target._dataProxy = dataProxy;
  }
}

function pathsToString(paths) {
  if (Array.isArray(paths)) {
    return paths.map(function (item, index) {
      if (index === 0) {
        return item;
      }

      if (+item >= 0) {
        return "[".concat(item, "]");
      }

      if (typeof item === 'string') {
        return ".".concat(item);
      }

      return '';
    }).join('');
  }

  if (typeof paths === 'string') {
    return paths;
  }

  return '';
}

var nameType = ['hump', 'uppercase', 'normal', 'middledash'];
/**
 * 解析path转成数组
 * @param {string} path
 * return {array}
 */

var getComponent = function getComponent(widget, components) {
  var component;

  if (typeof widget === 'string' && (0, _tools.isObject)(components)) {
    var i = 0;

    while (nameType[i]) {
      switch (nameType[i]) {
        case 'normal':
        case 'middledash':
          component = components[widget];
          break;

        case 'hump':
          component = components[(0, _tools.lineToHump)(widget)];
          break;

        case 'uppercase':
          component = components[(0, _tools.firstUpperCase)(widget)];
          break;
      }

      if (component) {
        return component;
      }

      i += 1;
    }
  }

  return component;
};

exports.getComponent = getComponent;

function makePaths(names, index) {
  names = resolvePath(names);

  if (+names[0] >= 0) {
    names[0] = index;
  } else {
    names.unshift(index);
  }

  return names;
}

function addIndexToPaths(item, index) {
  if ((0, _tools.isObject)(item)) {
    item.name = makePaths(item.name, index);
    item.dataBind = makePaths(item.dataBind, index);
  }
}
/**
 * 解析path转form字符串
 * @param {string | string[] | number[]} path  路径
 * return {string}
 */


var resolvePathForm = function resolvePathForm(path) {
  if (typeof path === 'string') {
    return path;
  }

  if (path && Array.isArray(path) && path.length) {
    var names = '';
    path.forEach(function (key, index) {
      // key = 1 || key = '1'
      if (typeof key === 'number' || /^\d+$/.test(key)) {
        names += "[".concat(key, "]");
      } else {
        names += "".concat(index !== 0 ? '.' : '').concat(key);
      }
    });
    return names;
  }

  return '';
};
/**
 * 获取form唯一标志
 * @param {string} name 名字
 * @param {string|string[]|number[]} path 路径
 * return {string}
 */


exports.resolvePathForm = resolvePathForm;

function getFormId(name, path) {
  if (path) {
    return "".concat(resolvePathForm(path), ".").concat(name);
  }

  return typeof name === 'undefined' ? '' : name;
} // 重构代码


function getPath(data) {
  var dataBind = data.dataBind;
  return resolvePath(dataBind);
}

function getDataProxyFromNameMap(names, nameMap) {
  var _get2;

  return (_get2 = (0, _lodash.get)(nameMap, names)) === null || _get2 === void 0 ? void 0 : _get2._dataProxy;
}

function getDataFromNameMap(names, nameMap) {
  var _get3;

  return (_get3 = (0, _lodash.get)(nameMap, names)) === null || _get3 === void 0 ? void 0 : _get3._data;
}

function getDataCloneFromNameMap(names, nameMap) {
  var _get4;

  return (_get4 = (0, _lodash.get)(nameMap, names)) === null || _get4 === void 0 ? void 0 : _get4._dataClone;
}

function getAllDataFromNameMap(names, nameMap) {
  var target = (0, _lodash.get)(nameMap, names);
  return {
    _data: target._data,
    _dataClone: target._dataClone,
    _dataProxy: target._dataProxy
  };
}

function getValue(data) {
  var defaultValue = data.defaultValue,
      value = data.value;

  if (value != undefined) {
    return value;
  }

  return defaultValue;
}

function assignObj(leftData, rightData) {
  if (!(0, _tools.isObject)(leftData) && !(0, _tools.isObject)(rightData)) {
    return {};
  }

  if (!(0, _tools.isObject)(leftData) && (0, _tools.isObject)(rightData)) {
    return rightData;
  }

  if ((0, _tools.isObject)(leftData) && !(0, _tools.isObject)(rightData)) {
    return leftData;
  }

  Object.keys(rightData).forEach(function (key) {
    if (!(key in leftData)) {
      leftData[key] = rightData[key];
    } else if ((0, _tools.isObject)(leftData[key]) && (0, _tools.isObject)(rightData[key])) {
      leftData[key] = _extends(leftData[key], rightData[key]);
    } else {
      leftData[key] = rightData[key];
    }
  });
  return leftData;
}